export default __webpack_public_path__ + "static/media/standard-triplo.78fe30cb.jpg";